<div class="modal-header">
  <h4 class="modal-title pull-left no-text-transform">
    {{ 'general.noty_title_warning' | translate }}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="decline()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="blue-background padding">
  {{ "selling.confirm_modal_title" | translate }}
</div>
<div class="container-fluid py-15 px-0 text-center">
  {{ "selling.confirm_modal_description" | translate }}
</div>
<div class="modal-footer d-center-center">
  <button (click)="decline()" class="btn-solid btn-small black-btn">
    {{ 'general.cancel' | translate }}
  </button>
  <button (click)="confirm()" class="btn-solid btn-small ml-15">
    {{ 'general.confirm' | translate }}
  </button>
</div>